import { Slide } from "react-reveal";

const ICTconsultancyOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't just install equipments and setup their
                    functionality - we build structured, reliable ICT
                    environments that improve productivity, enable learning, and
                    support your operations long-term.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>ICT Audit & System Architecture</h3>
                      <ul>
                        <li>
                          <span>Business/School ICT needs audit</span>
                        </li>
                        <li>
                          <span>Existing infrastructure audit</span>
                        </li>
                        <li>
                          <span>
                            System architecture design(hardware, network,
                            software)
                          </span>
                        </li>
                        <li>
                          <span>
                            Capacity planning (users, devices, future growth)
                          </span>
                        </li>
                        <li>
                          <span>Budget planning & cost optimization</span>
                        </li>
                        <li>
                          <span>
                            Technology recommendations aligned with your goals
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Hardware Procurement, Supply & Deployment</h3>
                      <ul>
                        <li>
                          <span>
                            Reliable computers sourcing (desktops/laptops)
                          </span>
                        </li>
                        <li>
                          <span>
                            Printers, scanners & multifunction devices
                          </span>
                        </li>
                        <li>
                          <span>Servers & storage devices(NAS, backups)</span>
                        </li>
                        <li>
                          <span>
                            Networking hardware (routers, switches, access
                            points)
                          </span>
                        </li>
                        <li>
                          <span>Peripherals(UPS, keyboards, accessories)</span>
                        </li>
                        <li>
                          <span>
                            Professional installation, configuration & testing
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>School Computer Lab Design & Installation</h3>
                      <ul>
                        <li>
                          <span>Lab layout planning (space optimization)</span>
                        </li>
                        <li>
                          <span>Student workstation configuration</span>
                        </li>
                        <li>
                          <span>Teacher/admin control systems</span>
                        </li>
                        <li>
                          <span>Networked lab setup(shared resources)</span>
                        </li>
                        <li>
                          <span>Cable management & safety setup</span>
                        </li>
                        <li>
                          <span>
                            Exam-ready & learning-friendly environments
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Office ICT Environment & Workflow Setup</h3>
                      <ul>
                        <li>
                          <span>Employee workstation setup</span>
                        </li>
                        <li>
                          <span>
                            Shared systems(printers, storage, servers)
                          </span>
                        </li>
                        <li>
                          <span>Department-based configurations</span>
                        </li>
                        <li>
                          <span>
                            Internal communication & collaboration tools
                          </span>
                        </li>
                        <li>
                          <span>Device synchronization & integration</span>
                        </li>
                        <li>
                          <span>Multi-branch setup & synchronization</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Networking, Connectivity & Internet Systems</h3>
                      <ul>
                        <li>
                          <span>LAN (Local Area Network) setup</span>
                        </li>
                        <li>
                          <span>Structured cabling systems</span>
                        </li>
                        <li>
                          <span>Router & switch configuration</span>
                        </li>
                        <li>
                          <span>
                            Wifi design & optimization (coverage + speed)
                          </span>
                        </li>
                        <li>
                          <span>Internet setup & redundancy planning</span>
                        </li>
                        <li>
                          <span>Network performance tuning</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Software Systems & User Environment Configuration</h3>
                      <ul>
                        <li>
                          <span>Operating system installation & setup</span>
                        </li>
                        <li>
                          <span>Essential productivity software</span>
                        </li>
                        <li>
                          <span>Licensing & activation</span>
                        </li>
                        <li>
                          <span>User account setup & permissions</span>
                        </li>
                        <li>
                          <span>System performance optimization</span>
                        </li>
                        <li>
                          <span>School management systems integration</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Security, Surveillance & Access Control</h3>
                      <ul>
                        <li>
                          <span>CCTV system installation</span>
                        </li>
                        <li>
                          <span>Monitoring & recording systems</span>
                        </li>
                        <li>
                          <span>Basic cybersecurity setup</span>
                        </li>
                        <li>
                          <span>User access control systems</span>
                        </li>
                        <li>
                          <span>Data protection practices</span>
                        </li>
                        <li>
                          <span>Advanced cybersecurity solutions</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Cloud, Email & Business Systems Integration</h3>
                      <ul>
                        <li>
                          <span>Google workspace setup</span>
                        </li>
                        <li>
                          <span>Business email setup & configurations</span>
                        </li>
                        <li>
                          <span>Cloud storage & file sharing systems</span>
                        </li>
                        <li>
                          <span>Remote access & work-from-anywhere setup</span>
                        </li>
                        <li>
                          <span>Device synchronization across teams</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Backup, Recovery & System Reliability</h3>
                      <ul>
                        <li>
                          <span>Data backup systems (local & cloud)</span>
                        </li>
                        <li>
                          <span>Automated backup scheduling</span>
                        </li>
                        <li>
                          <span>Disaster recovery planning</span>
                        </li>
                        <li>
                          <span>Power backup (UPS systems)</span>
                        </li>
                        <li>
                          <span>System redundancy planning</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Training, Handover & User Enablement</h3>
                      <ul>
                        <li>
                          <span>Staff training on systems & tools</span>
                        </li>
                        <li>
                          <span>Admin training for internal management</span>
                        </li>
                        <li>
                          <span>Basic troubleshooting guidance</span>
                        </li>
                        <li>
                          <span>Best practices for system usage</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Maintenance, Support & Continous Improvement</h3>
                      <ul>
                        <li>
                          <span>Routine system maintenance</span>
                        </li>
                        <li>
                          <span>Troubleshooting & technical support</span>
                        </li>
                        <li>
                          <span>Performance monitoring</span>
                        </li>
                        <li>
                          <span>Hardware & software upgrades</span>
                        </li>
                        <li>
                          <span>ongoing improvements as needs evolve</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ICTconsultancyOffers;
